import React, { useState, useEffect } from "react";
import {
  FormStyle,
} from "../../login/components/RightSideContainer";
import { Button } from "../../../components/Button";
import { EKYC_LOGIN_WITH_PASSWORD, EKYC_SET_PASSWORD_TITLE } from "./constant";
import { useHistory } from "react-router-dom";
import { EKYC } from "../../../helpers/constants/routes";
import { MobileTextBox } from "../../../components/MobileTextBox";
import { getDeviceType } from "../../../utils/CommonFunction";
import { DeviceType } from "../../../helpers/constants/constant";
import FooterMobile from "../../login/components/FooterMobile";
import { triggerSimpleAjax } from "../../../helpers/httpHelper.js";
import {E_MYTRACK_PASSWORD_LOGIN,}from "../../../helpers/constants/ekycApiUrl.js";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import { black500 } from "../../../theme/colors.js";
import CommonInput from "../../login/componentLoginScreen/CommonInput";

const EMyTrackPasswordLogin = () => {
  const history = useHistory();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const PasswordIcon = showPassword ? VisibilityOffIcon : VisibilityIcon;
  const [data, setData] = React.useState({
    password: "",
    userPhoneNumber: "",
    username: "",
    token: "",
    isError: false,
    errorObj: {},
    isLoading: false,
    isSessionClear: false,
    mobileView: false,
  });

  useEffect(() => {
    
    const mobileView =
      getDeviceType() === DeviceType.MOBILE ||
      getDeviceType() === DeviceType.TABLET;

    const stateData = history?.location?.state || {};

    setData((prev) => ({
      ...prev,
      mobileView: mobileView,
      username: stateData?.name || "",
      userPhoneNumber: stateData?.phone || "",
      token: stateData?.token || "",
    }));

    const sessionData = JSON.parse(localStorage.getItem("451")) || {};
    if (Object.keys(sessionData).length) {
      setData((prev) => ({
        ...prev,
        isSessionClear: true,
        isError: true,
        errorObj: {
          ...sessionData,
        },
      }));

      localStorage.removeItem("451");
    }
  }, []);

  const onChangeAction = (e) => {
    const { name, value } = e.target;

    setData({ ...data, [name]: value });
  };

  const navigateToCouponLogin = (e) => {
    e && e.preventDefault();
    history.push(EKYC.COUPON_CODE_MOBILEFORGOTPASSWORD);
  };

  const handleSetPassword = () => {
    const { password } = data;

    let errors = {};

    if (!password) {
      errors.password = "Password is required";
    }

    if (password && password.length < 6) {
      errors.password = "Password must be at least 6 characters";
    }

    if (Object.keys(errors).length > 0) {
      setData((prev) => ({
        ...prev,
        isError: true,
        errorObj: errors,
      }));
      return;
    }

    setData((prev) => ({ ...prev, isLoading: true }));
    triggerSimpleAjax(
      E_MYTRACK_PASSWORD_LOGIN,
      "POST",
      {
        login_username: data.userPhoneNumber,
        password: data.password,
        method_of_login: "phone_password",
        platform: "my_track",
      },
      (response) => {
        console.log("Password set successfully", JSON.stringify(response));

        localStorage.setItem("sessionid", response?.sessionid);
        localStorage.setItem("userName", response?.username);
        localStorage.setItem("reload", "reload");
        setData((prev) => ({
          ...prev,
          isLoading: false,
          isError: false,
        }));

        if (data.mobileView) {
          history.push(EKYC.DASHBOARD);
        } else {
          window
            .swal({
              title: "Login Successful!",
              text: "Welcome to the dashboard.",
              icon: "success",
              button: false,
              timer: 2000,
            })
            .then(() => {
              history.push(EKYC.DASHBOARD);
            });
        }
      },
      (error) => {
        console.log("Failed Login", error);

        let errorMessage = "Something went wrong";
        if (error?.detail) {
          errorMessage = error.detail;
        }
        setData((prev) => ({
          ...prev,
          isLoading: false,
          isError: true,
          errorObj: {
            password: errorMessage,
          },
        }));
      },
    );
  };

  return data.mobileView ? (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "90%",
          maxWidth: "440px",
          padding: "2.5rem 1.5rem",
          marginTop: "-30px",
          backgroundColor: "#ffffff",
          borderRadius: "16px",
          boxShadow: "0 10px 25px rgba(0, 0, 0, 0.05)",
          zIndex: 2,
        }}
      >
        <h3 style={{ fontSize: 18, fontWeight: "600", color: "#333", marginBottom: "8px" }}>Enter Password 👋</h3>
        <p style={{ padding: 0, margin: "0 0 15px 0", fontSize: 14, color: "#666", textAlign: "center" }}>
          {EKYC_LOGIN_WITH_PASSWORD}
        </p>
        <FormStyle style={{ width: "100%" }}>
          <MobileTextBox
            labelName="Enter Password"
            placeholder="Enter Password"
            name="password"
            value={data.password}
            type={showPassword ? "text" : "password"}
            onChange={onChangeAction}
            error={data.isError}
            errorMessage={data.errorObj?.password}
            rightIcon={{
              icon: (
                <PasswordIcon
                  style={{
                    color: black500,
                    marginRight: "5px",
                    cursor: "pointer",
                  }}
                  onClick={() => setShowPassword((prev) => !prev)}
                />
              ),
            }}
          />

          <Button
            type="submit"
            onClick={handleSetPassword}
            isLoading={data.isLoading}
            width="100%"
            bgColor="#4770C1"
            borderRadius="8px"
            fontStyle={{ fontSize: "14px", marginTop: "35px" }}
            boxHeight="38px"
          >
            {data.isSessionClear ? "Logout All Session" : "Proceed"}
          </Button>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
              marginTop: "35px",
            }}
          >
            <span
              onClick={navigateToCouponLogin}
              style={{
                fontSize: "15px",
                color: "#4770C1",
                textDecoration: "underline",
                cursor: "pointer",
                fontWeight: "600",
              }}
            >
              Forgot Password
            </span>
          </div>
        </FormStyle>
      </div>

      <div style={{ alignItems: "center", marginTop: "20px", width: "90%", maxWidth: "440px" }}>
        <FooterMobile textStyle="small" showSecuritySection={true} />
      </div>
    </>
  ) : (
    <form className="login-Form" onSubmit={(e) => { e.preventDefault(); handleSetPassword(); }}>
      <h2 className="login-heading" style={{ marginBottom: 20 }}>
        Welcome to eMyTrack 👋
      </h2>
      <p style={{ color: "#777", marginBottom: 30, fontSize: "16px", fontFamily: "barlow" }}>
        {EKYC_LOGIN_WITH_PASSWORD}
      </p>

      <CommonInput
        type="password"
        label="Password"
        name="password"
        value={data.password}
        onChange={onChangeAction}
        error={data.isError ? data.errorObj?.password : ""}
        showToggle={true}
        autoFocus
      />

      <div
        style={{
          width: "70%",
          display: "flex",
          justifyContent: "space-between",
          marginTop: "45px",
          alignItems: "center",
        }}
      >
        <button
          className="next-button"
          type="submit"
          disabled={data.isLoading}
        >
          {data.isSessionClear ? "Logout All Session" : "Proceed"}
        </button>

        <span
          onClick={navigateToCouponLogin}
          style={{
            fontSize: "16px",
            color: "#4770C1",
            textDecoration: "underline",
            cursor: "pointer",
            fontWeight: "500",
            fontFamily: "barlow",
          }}
        >
          Forgot Password
        </span>
      </div>
    </form>
  );
};
export default EMyTrackPasswordLogin;
